// extracted by mini-css-extract-plugin
module.exports = {"firstHandRpt":"styles_firstHandRpt__ULpB7"};